import type { FC } from "react";

import {
  TPreviewCardProps,
} from "@/ui/components/data-display/Card/Card.config";

import { BaseCard } from "./BaseCard";
import { CardIntroduction } from "./CardIntroduction";


export const PreviewCard: FC<TPreviewCardProps> = (
  {
    image,
    title,
    tags,
    ...props
  },
) => (
  <BaseCard
    data-component="PreviewCard"
    image={{ fit: "cover", ...image }}
    ratio="4:3"
    tags={tags}
    {...props}
  >
    <CardIntroduction title={title} />
  </BaseCard>
);

PreviewCard.displayName = "PreviewCard";
